// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet polis-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto } from '../model/collectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto';

import type { PolisGetPolissenParams } from '../model/polisGetPolissenParams';

import type { Result1OfSUREbusinessCCSWebservicesFeaturesPolisPolisVersieLezenPolisDetailsDto } from '../model/result1OfSUREbusinessCCSWebservicesFeaturesPolisPolisVersieLezenPolisDetailsDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haalt de polissen op van een relatie
 */
export const polisGetPolissen = (
  params?: MaybeRef<PolisGetPolissenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto>(
    { url: `/api/v2/polissen`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getPolisGetPolissenQueryKey = (params?: MaybeRef<PolisGetPolissenParams>) => {
  return ['api', 'v2', 'polissen', ...(params ? [params] : [])] as const;
};

export const getPolisGetPolissenQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetPolissen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<PolisGetPolissenParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolissen>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetPolissenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetPolissen>>> = ({ signal }) =>
    polisGetPolissen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof polisGetPolissen>>,
    TError,
    TData
  >;
};

export type PolisGetPolissenQueryResult = NonNullable<Awaited<ReturnType<typeof polisGetPolissen>>>;
export type PolisGetPolissenQueryError = ErrorType<void>;

/**
 * @summary Haalt de polissen op van een relatie
 */

export function usePolisGetPolissen<
  TData = Awaited<ReturnType<typeof polisGetPolissen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<PolisGetPolissenParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolissen>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetPolissenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haal de details van een individuele polis op
 */
export const polisGetPolisDetails = (
  polisnummer: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummer = unref(polisnummer);

  return customInstance<Result1OfSUREbusinessCCSWebservicesFeaturesPolisPolisVersieLezenPolisDetailsDto>(
    { url: `/api/v2/polissen/${polisnummer}/details`, method: 'GET', signal },
    options,
  );
};

export const getPolisGetPolisDetailsQueryKey = (
  polisnummer: MaybeRef<string | undefined | null>,
) => {
  return ['api', 'v2', 'polissen', polisnummer, 'details'] as const;
};

export const getPolisGetPolisDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetPolisDetails>>,
  TError = ErrorType<void>,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetPolisDetailsQueryKey(polisnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetPolisDetails>>> = ({ signal }) =>
    polisGetPolisDetails(polisnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(polisnummer) !== null && unref(polisnummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>;
};

export type PolisGetPolisDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisGetPolisDetails>>
>;
export type PolisGetPolisDetailsQueryError = ErrorType<void>;

/**
 * @summary Haal de details van een individuele polis op
 */

export function usePolisGetPolisDetails<
  TData = Awaited<ReturnType<typeof polisGetPolisDetails>>,
  TError = ErrorType<void>,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetPolisDetailsQueryOptions(polisnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
